<template>
  <b-card>
    <template #header>
      <h5 class="mb-0">{{ title }}</h5>
    </template>
    <div class="chart-container px-1">
      <div v-if="isLoading" class="text-center py-3">
        <b-spinner variant="primary" :label="$t('Loading...')"></b-spinner>
        <p>{{ $t('Loading data') }}</p>
      </div>
      <vue-apex-charts
          v-else-if="yValues.length > 2"
          type="line"
          :options="chartOptions"
          :series="series"
          :width="dynamicWidth"
          :height="chartHeight"/>
      <div class="text-center" v-show="(!yValues || yValues.length < 2) && !isLoading">
        <h4>{{ $t('No data found') }}</h4>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    VueApexCharts,
    BCard,
    BSpinner,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    seriesName: {
      type: String,
      default: 'Series',
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    xValues: {
      type: Array,
      required: true,
    },
    yValues: {
      type: Array,
      required: true,
    },
    chartHeight: {
      type: Number,
      default: 450,
    },
    chartWidth: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          id: 'rpm-chart',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
          },
        },
        xaxis: {
          categories: this.xValues.map(this.formatDateLabel),
          labels: {
            rotate: -45,
            rotateAlways: true,
            showDuplicates: true,
          },
          scrollbar: {
            enabled: false,
          },
        },
        yaxis: {},
        stroke: {
          curve: 'smooth',
        },
        markers: { 
          size: 4, 
          colors: '#0396c7', 
          strokeColors: '#fff', 
          strokeWidth: 2, 
          strokeOpacity: 0.9, 
          strokeDashArray: 0, 
          fillOpacity: 1, 
          discrete: [], 
          shape: "circle", 
          radius: 2, 
          offsetX: 0, 
          offsetY: 0, 
          showNullDataPoints: true, 
          hover: {
            size: undefined, 
            sizeOffset: 3 
          }
        },
      },
      series: [
        {
          name: this.seriesName,
          data: this.yValues,
        },
      ],
    };
  },
  computed: {
    dynamicWidth() {
      const dataLength = this.xValues.length;
      const calculatedWidth = 100 + dataLength * 1.5;
      if (dataLength < 10) {
        return '98%';
      }
      else if (dataLength > 10 && dataLength <= 300) {
        return `${Math.min(calculatedWidth, 150)}%`;
      }
      else if (dataLength > 300 && dataLength <= 1000) {
        return `200%`;
      }
      return `${calculatedWidth}%`;
    },
  },
  methods: {
    formatDateLabel(dateString) {
      const [fullDate, time] = dateString.split("T");
      const [year, month, day] = fullDate.split("-");
      const [hours, minutes] = time.split(":");
      return `${day}/${month} - ${hours}:${minutes}`;
    },
  },
  watch: {
    xValues(newXValues) {
      this.chartOptions.xaxis.categories = newXValues.map(this.formatDateLabel);
    },
    yValues(newYValues) {
      this.series[0].data = newYValues;
    },
    seriesName(newSeriesName) {
      this.series[0].name = newSeriesName;
    },
  },
};
</script>

<style scoped lang="scss">
.chart-container {
  overflow-x: auto;
  width: 100%;
}
</style>
